import { Entry, Track } from "../../GratefulDB";

export function entryVenueCoverage(entry: Entry) {
  return `Live at ${entry.venue}, ${entry.coverage}`;
}

export function constructTrackUrl(
  entry: Entry,
  track: Track,
  passwordHash?: string
): string {
  let src = `https://${entry.hosts[0]}${entry.directory}/${track.name}`;
  if (process.env.REACT_APP_ALTERNATE_URL_SCHEME === "true") {
    src = `https://${entry.hosts[0]}${entry.directory}?id=${track.name}`;
    if (process.env.REACT_APP_PASSWORD_REQUIRED === "true" && passwordHash) {
      src += `&password=${passwordHash}`;
    }
  }
  return src;
}
